import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FilesPage } from "@/features/files/FilesPage";

const search = z.object({
  view: z.enum(["list", "grid"]).optional(),
  file: z.string().optional(),
});

export const Route = createFileRoute("/_app/files/$folder")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { folder } = Route.useParams();
  return <FilesPage search={Route.useSearch()} folderId={folder} />;
}
